export const UPDATE_USER_STATE = 'UPDATE_USER_STATE'
export const UPDATE_USER_MARKET = 'UPDATE_USER_MARKET'
export const UPDATE_USER_MARKET_REGION = 'UPDATE_USER_MARKET_REGION'
export const UPDATE_USER_LANGUAGE = 'UPDATE_USER_LANGUAGE'
export const UPDATE_USER_SAVE_STATUS = 'UPDATE_USER_SAVE_STATUS'

export const SEND_NOTIFICATION = 'sendNotification'

export const SET_EDIT_STATE = 'EDIT.SET_EDIT_STATE'
export const SET_EDITABLE_ACTIVE_STATE = 'EDIT.SET_EDITABLE_ACTIVE_STATE'
export const SET_EDIT_UNSAVED = 'EDIT.SET_EDIT_UNSAVED'

export const SET_SAVING_STATE = 'EDIT.SET_SAVING_STATE'
export const SET_RECENTLY_SAVED_STATE = 'EDIT.SET_RECENTLY_SAVED_STATE'

export const FILTER_MUTATIONS = {
  MARKET_SELECTED: 'MARKET_SELECTED',
  SET_MARKETS_LIST: 'SET_MARKETS_LIST',
  SET_SEARCH_TERM: 'SET_SEARCH_TERM',
  SEARCHING: 'SEARCHING',
  FINISHED_SEARCH: 'FINISHED_SEARCH',
  SET_TYPE_SELECT: 'SET_TYPE_SELECT',
  SET_REGIONS_SELECTED: 'SET_REGIONS_SELECTED',
  SET_REGIONS_LIST: 'SET_REGIONS_LIST',
  SET_SORT_BY: 'SET_SORT_BY',
  SET_CATS_SELECTED: 'SET_CATS_SELECTED',
  SET_CATS_LIST: 'SET_CATS_LIST',
  SET_RELEVANCE: 'SET_RELEVANCE',
  SET_PAGE_TYPE: 'FILTER_MUTATIONS.SET_PAGE_TYPE',
  SET_RATES_LIST: 'FILTER_MUTATIONS.SET_RATES_LIST',
  SET_RATES_SELECTED: 'FILTER_MUTATIONS.SET_RATES_SELECTED',
  SET_EXPERIENCE_LIST: 'FILTER_MUTATIONS.SET_EXPERIENCE_LIST',
  SET_EXPERIENCE_SELECTED: 'FILTER_MUTATIONS.SET_EXPERIENCE_SELECTED',
  SET_MATCH_TYPE: 'FILTER_MUTATIONS.SET_MATCH_TYPE',
  SET_OWN_LIST: 'FILTER_MUTATIONS.SET_OWN_LIST',
  SET_OWN_SELECTED: 'FILTER_MUTATIONS.SET_OWN_SELECTED',
  SET_ENGAGED_LIST: 'FILTER_MUTATIONS.SET_ENGAGED_LIST',
  SET_ENGAGED_SELECTED: 'FILTER_MUTATIONS.SET_ENGAGED_SELECTED',
  SET_DIVISION_LIST: 'FILTER_MUTATIONS.SET_DIVISION_LIST',
  SET_DIVISION_SELECTED: 'FILTER_MUTATIONS.SET_DIVISION_SELECTED',
  SET_FILTER_SETUP_COMPLETE: 'FILTER_MUTATIONS.SET_FILTER_SETUP_COMPLETE',
}

export const JOB_MUTATIONS = {
  UPDATE_LIST: 'JOB_MUTATIONS.UPDATE_LIST',
  ADD_TO_CACHE: 'JOB_MUTATIONS.ADD_TO_CACHE',
  SET_KEY: 'JOB_MUTATIONS.SET_KEY',
  SET_RECOMMENDED_JOBS: 'JOB_MUTATIONS.SET_RECOMMENDED_JOBS',
  SET_MATCHED_JOBS: 'JOB_MUTATIONS.SET_MATCHED_JOBS',
  SET_ALL_JOBS: 'JOB_MUTATIONS.SET_ALL_JOBS',
}

export const PROFILES_MUTATIONS = {
  ADD_TO_CACHE: 'PROFILES_MUTATIONS.ADD_TO_CACHE',
  SET_KEY: 'PROFILES_MUTATIONS.SET_KEY',
  NEXT_PAGE: 'PROFILES_MUTATIONS.NEXT_PAGE',
  RESET_PAGE_NUMBER: 'PROFILES_MUTATIONS.RESET_PAGE_NUMBER',
  REQUEST_SENT: 'PROFILES_MUTATIONS.REQUEST_SENT',
  RESPONSE_RECEIVED: 'PROFILES_MUTATIONS.RESPONSE_RECEIVED',
}

export const EXPENSE_REPORT_MUTATIONS = {
  SET_REPORTS: 'EXPENSE_REPORT_MUTATIONS.SET_REPORTS',
  ADD_REPORT: 'EXPENSE_REPORT_MUTATIONS.ADD_REPORT',
  UPDATE_REPORT: 'EXPENSE_REPORT_MUTATIONS.UPDATE_REPORT',
  DELETE_REPORT: 'EXPENSE_REPORT_MUTATIONS.DELETE_REPORT',
  ADD_LINE_ITEM: 'EXPENSE_REPORT_MUTATIONS.ADD_LINE_ITEM',
  UPDATE_LINE_ITEM: 'EXPENSE_REPORT_MUTATIONS.UPDATE_LINE_ITEM',
  DELETE_LINE_ITEM: 'EXPENSE_REPORT_MUTATIONS.DELETE_LINE_ITEM',
}

export const TABLE_BILLS_MUTATIONS = {
  ADD_HIRES_WITH_RECENT_BILL_REMINDER: 'TABLE_BILLS_MUTATIONS.ADD_HIRES_WITH_RECENT_BILL_REMINDER',
  SET_DEFAULT_BILL_REMINDER_TEXT: 'TABLE_BILLS_MUTATIONS.SET_DEFAULT_BILL_REMINDER_TEXT',
}

export const CONVERSATION_MUTATIONS = {
  SET_DRAFT_MESSAGE: 'CONVERSATION_MUTATIONS.SET_DRAFT_MESSAGE',
}

export const APP_NAVIGATION = {
  TOGGLE_SIDEBAR_OPEN_STATE: 'APP_NAVIGATION.TOGGLE_SIDEBAR',
  TOGGLE_DESKTOP_SIDEBAR_OPEN_STATE: 'APP_NAVIGATION.TOGGLE_DESKTOP_SIDEBAR',
  UPDATE_SIDEBAR_OPEN_STATE: 'APP_NAVIGATION.UPDATE_SIDEBAR_OPEN_STATE',
  UPDATE_DESKTOP_SIDEBAR_OPEN_STATE: 'APP_NAVIGATION.UPDATE_DESKTOP_SIDEBAR_OPEN_STATE',
}
